





























































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import { PropOptions } from "vue";
import Miembro from "../../models/miembro/miembro.model";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import Persona from "@/models/persona/persona.model";
import { Utils } from "@/core/Utils";
import TramiteBeneficiario from "@/models/tramite/tramiteBeneficiario.model";
import SolicitudCambioComposicionFamiliar, {
  SolicitudCambioComposicionFamiliarCorreccion,
  SolicitudCambioComposicionFamiliarDocumento
} from "@/models/tramite/solicitud-cambio-composicion-familiar/";
import Beneficiario from "@/models/beneficiario/beneficiario.model";
import TipoTramite from "@/models/tipoTramite";
import BaseRepository from "@/core/HttpResources/BaseRepository";

import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import Helpers from "@/helpers/helper";

@Component
export default class CambioComposicionFamiliarCorreccionResumen extends GenericBTable<
  SolicitudCambioComposicionFamiliarCorreccion
> {
  @Prop() readonly tipoTramite!: TipoTramite;
  @Prop() readonly solicitante!: Persona;
  @Prop() readonly beneficiario!: Beneficiario;
  @Prop() readonly content!: TramiteBeneficiario;

  get hogarId() {
    if (this.beneficiario && this.beneficiario.hogarId)
      return this.beneficiario.hogarId;
    return 0;
  }
  get hogarCode() {
    if (this.beneficiario && this.beneficiario.codigoHogar)
      return this.beneficiario.codigoHogar;
    return "";
  }
  get tramiteBeneficiarioId() {
    if (this.content && this.content.id) return this.content.id;
    if (this.$route.params.id) return this.$route.params.id;
    return 0;
  }
  created() {
    this.tableConfig.controller =
      "SolicitudCambioComposicionFamiliarCorreccion";
    this.tableConfig.include =
      "CentroAcademico|MiembroSiuben.Parentesco|Miembro.Parentesco|MiembroSiuben.Persona|Miembro.Persona|MiembroSiuben.Persona.CentroAcademico|Miembro.Persona.CentroAcademico|Parentesco";
    this.tableConfig.activeActions = false;
    this.tableConfig.detailed = true;
    this.tableConfig.whereParams = this.getWhereParams();
    this.formatColumns();
  }
  getWhereParams() {
    let result = [];
    result.push(
      `SolicitudCambioComposicionFamiliar.TramiteBeneficiarioId="${this.tramiteBeneficiarioId}"`
    );

    return result.join("&");
  }
  dataRow(row: any) {
    if (row.miembro) {
      return row.miembro;
    }
    if (row.miembroSiuben) {
      return row.miembroSiuben;
    }
    return row;
  }
  getPersona(
    id: number,
    nombre: string,
    cedula: string,
    foto: string,
    model: Persona
  ) {
    let persona = model || new Persona();
    persona.id = id;
    persona.nombreCompleto = nombre;
    persona.cedula = cedula;
    persona.foto = foto;
    return persona;
  }
  formatColumns() {
    let persona = new BTableColumn(
      "miembro.PersonaId",
      this.isMobile ? "Nombre" : "Nombre completo"
    );
    persona.customTemplate = true;
    persona.templateSlot = "persona";
    let edad = new BTableColumn("miembro.persona.fechaNacimiento", "Edad");
   edad.type = BTableColumnType.Custom;
    edad.customFilter = Helpers.Filters.EdadText;
     let fechaNacimiento = new BTableColumn("miembro.persona.fechaNacimiento", "Fecha nacimiento");
     fechaNacimiento.type = BTableColumnType.Date;
    let parentesco = new BTableColumn(
      "miembro.parentescoNombre",
      "Parentesco",
      false
    );
    parentesco.customTemplate = true;
    parentesco.templateSlot = "parentesco";
    let sexo = new BTableColumn("miembro.persona.sexo", "Genero");
    sexo.customTemplate = true;
    sexo.templateSlot = 'sexo';
    sexo.type = BTableColumnType.Custom;
    sexo.customFilter = Helpers.Filters.Sexo;
    this.tableConfig.insertColumns(persona, edad,fechaNacimiento, parentesco, sexo);
  }
}
